import { render, staticRenderFns } from "./page005.vue?vue&type=template&id=4f778da8&scoped=true&"
import script from "./page005.vue?vue&type=script&lang=js&"
export * from "./page005.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f778da8",
  null
  
)

export default component.exports